import React, { useState } from 'react';
import { func } from 'prop-types';
import { t } from 'Locale';
import { useStore } from 'Store';
import SendCode from './SendCode';

/**
 * @typedef {{ onSubmitted(data: { type: string }): void }} Props
 * @typedef {{ username: string, errorMessage: string | null }} State
 */

/**
 * @param {Props} props
 */
const SendCodePin = ({ onSubmitted, onClose }) => {
    const pinType = 'PARENTAL';
    const { appManager } = useStore();
    const [errorMessage, setErrorMessage] = useState(null);

    const onGetVerificationCode = async () => {
        try {
            await appManager.api.requestPinReset({
                type: pinType
            });
            onSubmitted({
                type: pinType
            });
        } catch (error) {
            setErrorMessage(error.localizedMessage);
        }
    };

    return (
        <SendCode
            title={t('COMMON.RESET_FORGOTTEN_PIN')}
            description={t('SETTINGS.PARENTAL_RESET_DESCRIPTION')}
            onGetVerificationCode={onGetVerificationCode}
            errorMessage={errorMessage}
            close={onClose}
        />
    );
};

SendCodePin.propTypes = {
    onSubmitted: func.isRequired
};

export default SendCodePin;
